const sectionLine = () => {
    // Get references to the target elements
    const headingElement = document.querySelector('.content-image__heading');
    const menuElement = document.querySelector('.menus__menu');
    const lineElement = document.querySelector('.js-section-line');

    if ( headingElement && menuElement && lineElement ) {        
        // Initial positioning of the line
        positionLine(headingElement, menuElement, lineElement);
    }
}

sectionLine();

// Recalculate the position if the window is resized
window.addEventListener('resize', sectionLine);

// Function to position the line
function positionLine(headingElement, menuElement, lineElement) {
    const headingBottom = headingElement.getBoundingClientRect().bottom;
    const menuTop = menuElement.getBoundingClientRect().bottom - 16;
    console.log(menuTop, headingBottom);
    
    // Calculate the height of the line
    const lineHeight = menuTop - headingBottom;

    // Set the top and height of the line element
    lineElement.style.height = `${lineHeight}px`;
}